import { fileConstants } from "../constants";
import { fileService } from "../services";
import { loaderMaskActions } from ".";
import { handleErrors } from "../../utils";

export const fileActions = {
  getAll,
  getAllByFileId,
  getAllStartFilesDetails,
  expandRow,
  setActiveRow,
  clearFiles,
  resetFiles,

  setFileSelection,
  toggleSelectAll,
  toggleHiddenColumn,
  toggleShowColumnMenu,
  setHiddenColumn,

  setChannelFileSelection,
  resetChannelFileSelection,

  getDownloadFile,
  toggleDownLoadSpinner,

  setDownloadFileParams,
  setEmailSent,
  setEmailFailedButDownloadReady,
};


function setEmailFailedButDownloadReady(emailDownloadFileParams) {
  return { type: fileConstants.SET_EMAIL_FAILED_BUT_DOWNLOAD_READY, emailDownloadFileParams };
}

function setEmailSent(emailSent) {
  return { type: fileConstants.SET_EMAIL_SENT, emailSent };
}

function setDownloadFileParams(downloadFileParams) {
  return { type: fileConstants.SET_DOWNLOAD_FILE_PARAMS, downloadFileParams };
}

function toggleDownLoadSpinner(showSpinner) {
  if(!showSpinner) {
    // clear all localStorage for downloadFile
    localStorage.setItem('downloadLoadingForFiles', '');
		localStorage.setItem('downloadLoadingForDocuments', '');
		localStorage.setItem('downloadPipelineId', '');
		localStorage.setItem('isSendingEmail', '');
  }
  return { type: fileConstants.TOGGLE_DOWNLOAD_SPINNER, showSpinner };
}

function setHiddenColumn(hiddenColumns) {
  return { type: fileConstants.SET_HIDDEN_COLUMNS, hiddenColumns };
}

function toggleHiddenColumn(column) {
  return { type: fileConstants.TOGGLE_HIDDEN_COLUMNS, column };
}

function toggleShowColumnMenu(column) {
  return { type: fileConstants.TOGGLE_SHOW_COLUMN_MENU, column };
}

function toggleSelectAll(pageItemCount) {
  return { type: fileConstants.TOGGLE_SELECT_ALL, pageItemCount };
}

function setFileSelection(fileId) {
  return { type: fileConstants.TOGGLE_SELECTION, fileId };
}

function setChannelFileSelection(fileId, channelName, channelOperator) {
  return { type: fileConstants.TOGGLE_CHANNEL_SELECTION, fileId, channelName, channelOperator };
}

function resetChannelFileSelection() {
  return { type: fileConstants.RESET_CHANNEL_SELECTION };
}

function getAll(params, loadingText) {
  return dispatch => {
    dispatch(loaderMaskActions.show(loadingText || "Loading files..."));
    dispatch(request());
    return fileService.getAll(params).then(
      data => {
        dispatch(loaderMaskActions.hide(""));
        return dispatch(success(data.Data, data.TotalPages));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(loaderMaskActions.hide(""));
        return dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: fileConstants.GETALL_REQUEST };
  }
  function success(files, TotalPages) {
    return { type: fileConstants.GETALL_SUCCESS, files, TotalPages };
  }
  function failure(error) {
    return { type: fileConstants.GETALL_FAILURE, error };
  }
}


function getDownloadFile(params) {
  return dispatch => {
    dispatch(request());
    return fileService.getAll(params).then(
      data => {
        return dispatch(success(data.Data, data.TotalPages));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(loaderMaskActions.hide(""));
        return dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: fileConstants.GET_DOWNLOAD_REQUEST };
  }
  function success(files, TotalPages) {
    return { type: fileConstants.GET_DOWNLOAD_SUCCESS, files, TotalPages };
  }
  function failure(error) {
    return { type: fileConstants.GETALL_FAILURE, error };
  }
}

function getAllByFileId(params, loadingText) {
  return dispatch => {
    dispatch(loaderMaskActions.show(loadingText || "Loading files..."));
    dispatch(request());
    fileService.getAll(params).then(
      data => {
        dispatch(loaderMaskActions.hide(""));
        dispatch(success(data.Data, data.TotalPages, params));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(loaderMaskActions.hide(""));
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: fileConstants.GETALL_REQUEST };
  }
  function success(files, TotalPages, params) {
    return {
      type: fileConstants.GET_BY_FILEID_SUCCESS,
      files,
      TotalPages,
      params
    };
  }
  function failure(error) {
    return { type: fileConstants.GETALL_FAILURE, error };
  }
}

function getAllStartFilesDetails(params, loadingText) {
  return dispatch => {
    dispatch(loaderMaskActions.show(loadingText || "Loading files..."));
    dispatch(request());
    fileService.getAllStartFilesDetails(params).then(
      data => {
        dispatch(success(data.Data, data.TotalPages, params));
        dispatch(loaderMaskActions.hide(""));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
        dispatch(loaderMaskActions.hide(""));
      }
    );
  };

  function request() {
    return { type: fileConstants.GETALL_REQUEST };
  }
  function success(files, TotalPages, params) {
    return {
      type: fileConstants.GET_ALL_START_FILES_DETAILS_SUCCESS,
      files,
      TotalPages,
      params
    };
  }
  function failure(error) {
    return { type: fileConstants.GETALL_FAILURE, error };
  }
}

function expandRow(rowIndex) {
  return { type: fileConstants.EXPAND_ROW, rowIndex };
}

function setActiveRow(rowIndex) {
  return { type: fileConstants.SET_ACTIVE_ROW, rowIndex };
}

function clearFiles() {
  return { type: fileConstants.CLEAR_FILES };
}

function resetFiles() {
  return { type: fileConstants.FILES_RESET };
}
